import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const areas = [
  "Leamington Spa",
  "Warwick",
  "Kenilworth",
  "Coventry",
  "Stratford-upon-Avon",
  "Southam",
  "Rugby",
  "Solihull",
  "Henley-in-Arden",
  "Whitnash",
  "Wellesbourne",
  "Cubbington",
];

export default function ServiceAreas() {
  return (
    <section id="areas" className="py-24 sm:py-32 bg-[#F8F9FA] border-t border-[#0B1215]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="font-mono-label text-[#FF5A36] mb-4">· SERVICE AREA</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0B1215] tracking-tighter leading-[0.95]">
              Warwickshire<br />
              & <span className="italic font-light">surrounding</span> areas.
            </h2>
            <p className="mt-6 text-[#495057] leading-relaxed max-w-md">
              Based in Leamington Spa — covering everywhere within a sensible drive. If your
              postcode isn't on the list, just ask. Travel for larger jobs is always considered.
            </p>
          </div>

          <div className="lg:col-span-7" data-testid="service-areas-list">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {areas.map((a, i) => (
                <motion.div
                  key={a}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.35, delay: i * 0.03 }}
                  className="border-2 border-[#0B1215] px-4 py-3 flex items-center gap-2 hover:bg-[#FF5A36] hover:text-[#F8F9FA] hover:border-[#FF5A36] transition-colors"
                  data-testid={`area-${a.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <MapPin size={14} className="shrink-0" />
                  <span className="font-display text-sm sm:text-base tracking-tight">{a}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
